module Meevo.Plugins.Reports {
    import IReportControl = Meevo.Model.IReportControl;
    import IReportGeneralInfo = Meevo.Model.IReportGeneral;

    const reportShortCut = {
        'CORE': {
            controls_for_co: ['DateRange', 'LocationMultiSelector', 'LocationGroupMultiSelector'],
            controls_for_location: ['DateRange']
        }
    }

    class ReportSchedulerControlsListComponent implements angular.IComponentController {
        reportControls: IReportControl[];
        form: angular.IFormController;
        hierarchyForm: ng.IFormController;
        selectedReport: IReportGeneralInfo;
        validationJson: Record<string, string>;
        reportModel: Record<string, string>;
        startDayOfWeek: number;
        filterControls: IReportControl[];


        static $inject = ["meevo.components.common.IdentityService"];

        constructor(protected identityService: Meevo.Components.Common.IIdentityService) {

            this.filterControls = this.reportControls.filter((item: IReportControl) => {
                return reportShortCut[this.selectedReport.shortCut][(this.identityService.inCentralOfficeMode()) ? 'controls_for_co' : 'controls_for_location'].indexOf(item.displayName) !== -1
            })
        }

    }

    angular.module('meevo.plugins.reportScheduler')
        .component('meevoReportSchedulerControlsList', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/reportScheduler/components/report-scheduler-controls-list/report-scheduler-controls-list.component.html',
            controller: ReportSchedulerControlsListComponent,
            controllerAs: '$ctrl',
            bindings: {
                reportControls: '<',
                form: '<',
                hierarchyForm: '<',
                selectedReport: '<',
                validationJson: '<',
                startDayOfWeek: '<',
                mainModel: '<',
                ngDisabled: '<ngDisabled',
            }
        });
}
